import React, { useState } from "react";
import { Lock, Save, AlertCircle, CheckCircle } from "lucide-react";
import PageHeader from "../../components/PageHeader";
import { changeAdminPassword } from "../../services/adminProfile";

const ChangePassword = () => {
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    setError("");
    setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      setError("Preencha todos os campos");
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      setError("A confirmação de senha não coincide");
      return;
    }

    if (form.newPassword.length < 5) {
      setError("A nova senha deve ter pelo menos 5 caracteres");
      return;
    }

    setLoading(true);
    try {
      await changeAdminPassword({
        currentPassword: form.currentPassword,
        newPassword: form.newPassword
      });
      setSuccess("Senha alterada com sucesso");
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      setError(err.message || "Erro ao alterar senha");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumb="Conta & Segurança"
        title="Alterar Senha"
        subtitle="Atualize suas credenciais de acesso ao portal administrativo"
      />

      <div className="neumorphic-card rounded-3xl p-6 sm:p-8 border border-white/5 max-w-xl space-y-6">
        {error && (
          <div className="p-4 rounded-2xl bg-rose-500/10 border border-rose-500/20 text-rose-300 text-xs font-semibold flex items-center gap-3">
            <AlertCircle size={18} /> {error}
          </div>
        )}

        {success && (
          <div className="p-4 rounded-2xl bg-emerald-500/10 border border-emerald-500/20 text-emerald-300 text-xs font-semibold flex items-center gap-3">
            <CheckCircle size={18} /> {success}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1.5">
              Senha Atual
            </label>
            <div className="relative">
              <input
                type="password"
                required
                value={form.currentPassword}
                onChange={handleChange("currentPassword")}
                placeholder="••••••••"
                className="w-full px-3.5 py-2.5 bg-[#191c1e] border border-white/10 rounded-xl text-xs text-white placeholder-gray-500 focus:outline-none focus:border-purple-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1.5">
              Nova Senha
            </label>
            <input
              type="password"
              required
              value={form.newPassword}
              onChange={handleChange("newPassword")}
              placeholder="Mínimo 5 caracteres"
              className="w-full px-3.5 py-2.5 bg-[#191c1e] border border-white/10 rounded-xl text-xs text-white placeholder-gray-500 focus:outline-none focus:border-purple-500"
            />
          </div>

          <div>
            <label className="block text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1.5">
              Confirmar Nova Senha
            </label>
            <input
              type="password"
              required
              value={form.confirmPassword}
              onChange={handleChange("confirmPassword")}
              placeholder="Digite novamente a nova senha"
              className="w-full px-3.5 py-2.5 bg-[#191c1e] border border-white/10 rounded-xl text-xs text-white placeholder-gray-500 focus:outline-none focus:border-purple-500"
            />
          </div>

          <div className="pt-3 border-t border-white/5 flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2.5 create-event-btn text-xs font-bold text-white rounded-xl shadow-purple-glow flex items-center gap-2"
            >
              <Save size={15} /> {loading ? "Salvando..." : "Alterar Senha"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
